import React, { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
import { getLoggedIn } from 'client/contexts/Login/selectors'
import Footer from 'client/components/Footer'
import Head from 'client/pages/Home/Head'
import Header from 'client/components/Header'
import LoginForm from 'src/comps/LoginForm'
import Page from 'src/comps/Page'
import { getServerSideProps as getServerSidePropsHandler } from 'src/pages/login/server'
import styles from 'client/pages/Login/styles.module.css'
import { buildRedirectLoginUrl } from 'src/utils/getRedirectLoginUrl'
import { ConfigType } from 'src/types/config'
import { ListOfAncillary } from '@s4l/stayforlong/booking/ListOfAncillary'

const pageId = 'login'

interface ISignInPageProps {
  config: ConfigType & { cookieReturnUrl: string | null }
  referrer: string | null
  ancillariesJSON: ReturnType<ListOfAncillary['toJSON']>
}
const LoginPage = ({ config, referrer, ancillariesJSON }: ISignInPageProps) => {
  const { cookieReturnUrl } = config

  const router = useRouter()
  const isLoggedIn = useSelector(getLoggedIn)

  useEffect(() => {
    if (!isLoggedIn) return
    const urlToRedirect = buildRedirectLoginUrl(referrer, cookieReturnUrl)

    router.push(urlToRedirect)
  }, [isLoggedIn, cookieReturnUrl, referrer, router])

  return (
    <Page config={config} pageId={pageId}>
      <Head />
      <Header pageId={pageId} hasLogin={false} backButton ancillariesJSON={ancillariesJSON} />

      <div className={styles.section}>
        <LoginForm title border />
      </div>

      <Footer />
    </Page>
  )
}

export const getServerSideProps = getServerSidePropsHandler

LoginPage.pageId = pageId
LoginPage.pagePathView = '/login'

export default LoginPage
